import { VectorLayerService } from '@nuxtDatakodeUtils/services/vectorLayer.service'
import type { FeatureLike } from 'ol/Feature'
import { Fill, Stroke, Style } from 'ol/style'

// noinspection JSUnusedGlobalSymbols
export class CommandVectorLayerService extends VectorLayerService {
    // noinspection JSUnusedGlobalSymbols
    protected override highlightOnlyFirst = true // highlight only one feature
    protected selectedCities: string[] = []
    protected editMode: boolean = false
    protected firstHighlightCities: string[] = []
    protected legendCreated: boolean = false

    override getPolygonStyle(feature: FeatureLike, isHighLighted: boolean, isSelected: boolean): Style {
        const insee: any = feature.get('insee')
        let effectiveHighlight = isHighLighted
        // override isHighLighted to false the first time after the selection
        if (isSelected && isHighLighted && !this.firstHighlightCities.includes(insee)) {
            effectiveHighlight = false
            this.firstHighlightCities.push(insee)
        }

        if (!isSelected && this.firstHighlightCities.includes(insee)) {
            this.firstHighlightCities = this.firstHighlightCities.filter(i => i !== insee)
        }

        if (!this.legendCreated) {
            effectiveHighlight = isHighLighted
        }

        if (isSelected && !this.firstHighlightCities.includes(insee))
            this.firstHighlightCities.push(insee)
        return new Style({
            fill: new Fill({
                color: this.getColor(effectiveHighlight, isSelected),
            }),
            stroke: new Stroke({
                color: '#000000ff',
                width: 1,
            }),
        })
    }

    setSelectedCities(newSelectedCities: []): void {
        this.selectedCities = newSelectedCities
    }

    override isSelected(feature: FeatureLike): boolean {
        return this.selectedCities.includes(feature.get('insee'))
    }

    setEditMode(isEditMode: boolean = false): void {
        this.editMode = isEditMode
    }

    override isHighlighted(feature: FeatureLike): boolean {
        if (!this.editMode)
            return false
        return this.isFeatureIn(feature, this.highlightedFeatures)
    }

    getColor(isHighLighted: boolean = false, isSelected: boolean = false): string {
        if (isSelected && isHighLighted)
            return 'rgba(213,8,8,0.74)'
        else if (isSelected)
            return 'rgba(82,213,8,0.74)'
        else if (isHighLighted)
            return 'rgba(82,213,8,0.38)'
        else
            return 'rgba(61,185,61,0)'
    }

    setLegendCreated(isCreated: boolean): void {
        this.legendCreated = isCreated
    }
}
